import {useAppStore} from '../appStore'

export const toastActions = {
  useShowSuccess: () => useAppStore(s => s.showSuccess),
  useShowError: () => useAppStore(s => s.showError),
  useResetToast: () => useAppStore(s => s.resetToast),
} as const
